export const style = {
  card: {
    header: {
      height: 50,
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
} as const;
